module.exports = __webpack_public_path__ + "img/info1.29ad8e33.png";